import { DocumentNode } from "@apollo/client";
import { Divider, Flex, Heading } from "@chakra-ui/react";
import { WithRequiredHasuraRoles } from "src/components/Permissions/WithRequiredHasuraRoles";
import { OtherProfiles } from "src/scenes/orgAdmin/userProfile/OtherProfiles";
import { HasuraRole } from "src/types/hasuraRole";
import { DelinkUser } from "./DelinkUser";

type Props = {
  personId: uuid;
  userId: string | undefined;
  refetchQueriesAfterDelink: (DocumentNode | string)[];
};
export const EditUserProfile: React.FC<Props> = ({
  personId,
  userId,
  refetchQueriesAfterDelink,
}) => {
  return (
    <WithRequiredHasuraRoles roles={[HasuraRole.ADMIN]}>
      <Divider />
      <Flex direction="column" gap="6">
        <Heading as="h2" variant="admin">
          Avela admin
        </Heading>
        <DelinkUser
          personId={personId}
          userId={userId}
          refetchQueriesAfterDelink={refetchQueriesAfterDelink}
        />
        {userId ? (
          <OtherProfiles userId={userId} excludePersonId={personId} />
        ) : null}
      </Flex>
    </WithRequiredHasuraRoles>
  );
};
